import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentHandoutComponent } from './component/supplementary-equipment-handout.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import {  ServiceResponseModule, TransportInfoPanelModule } from '@sdbn/common';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [SupplementaryEquipmentHandoutComponent],
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatSelectModule,
    MatCheckboxModule
  ],
   exports: [SupplementaryEquipmentHandoutComponent]
})
export class SupplementaryEquipmentHandoutModule { }
